export default function TagKit() {
  return <div>Tag kit</div>;
}
